import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@dealer-center/core-components";
import type {
  AutotraderFlagNames,
  CC9FlagNames
} from "@dealer-center/core-interfaces-third-party-launch-darkly";
import type { GenericFlags } from "@dealer-center/core-interfaces-third-party-launch-darkly";

export function LaunchDarklyAccordionItem({
  flags
}: {
  flags: GenericFlags<CC9FlagNames> | GenericFlags<AutotraderFlagNames>;
}) {
  return (
    <Accordion>
      <AccordionSummary>Launch Darkly Flags</AccordionSummary>
      <AccordionDetails>
        <pre>{JSON.stringify(flags, null, 2)}</pre>
      </AccordionDetails>
    </Accordion>
  );
}
